import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel } from "../../tools/Dictionary";
import { FaRegCircle } from "react-icons/fa";
import { MdOutlineLightMode, MdOutlineHighlightOff } from "react-icons/md";

const ComponentLightCodeModal = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const OnChangeLight = props.OnChangeLight;
  const OnCloseModal = props.OnCloseModal;

  //State
  const [loading] = useState(false);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });



  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "400px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ComponentEntity", "Choose the light status")}
        </div>
        <div className="page_modal_body_cont" style={{minHeight: "250px"}}>
          <div className="component_light_modal_cont">
            <div className="component_light_modal_item" onClick={() => OnChangeLight("X")} style={{ color: "#b30000" }}>
              <div className="component_legend_item_icon">
                <MdOutlineHighlightOff />
              </div>
              <div className="component_legend_item_label">
                {getLabel("ComponentEntity", "Light off")}
              </div>
            </div>
            <div className="component_light_modal_item" onClick={() => OnChangeLight("O")} style={{ color: "#008000" }}>
              <div className="component_legend_item_icon">
                <FaRegCircle />
              </div>
              <div className="component_legend_item_label">
                {getLabel("ComponentEntity", "Light on")}
              </div>
            </div>
            <div className="component_light_modal_item" onClick={() => OnChangeLight("F")} style={{ color: "#e68a00" }}>
              <div className="component_legend_item_icon" >
                <MdOutlineLightMode />
              </div>
              <div className="component_legend_item_label">
                {getLabel("ComponentEntity", "Flashing light")}
              </div>
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ComponentLightCodeModal;